export default {
    ATIVA: 0,
    CICATRIZADA: 1,
}